import React from 'react'
import { useStatusReportContext } from '../../statusReportContext'
import StatusReportSummary from '../../StatusReportSummary'

function ClientStatusReportSummaryDefaultLayout (props) {
  const { report, statuses, isLoading } = useStatusReportContext()

  return (
    <StatusReportSummary
      {...props}
      report={report}
      statuses={statuses}
      loading={isLoading}
    />
  )
}

ClientStatusReportSummaryDefaultLayout.propTypes = {}

export default ClientStatusReportSummaryDefaultLayout
